




































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import Enumerable from 'linq';
import * as api from '@/api/api';
import * as def from '@/common/definitions';

// tslint:disable-next-line:no-var-requires
const md5 = require('md5');

@Component({
  components: {
    CharacterIcon,
  },
})
export default class CharacterIconPicker extends Vue {
  @Prop() public value!: api.CharacterIcon;
  @Prop({
    default: false,
  }) public canUseFile!: boolean;
  private defaultIconId: number = 0;
  private type: number = 1;
  private email: string = '';
  private file?: File;
  private onValueChanging = false;

  private get defaultIconMax(): number {
    return def.DEFAULT_ICON_NUM;
  }

  @Watch('value')
  private getValue() {
    this.onValueChanging = true;
    this.type = this.value.type;
    this.onValueChanging = false;
  }

  @Watch('defaultIconId')
  @Watch('type')
  @Watch('email')
  private onInput() {
    if (!this.onValueChanging) {
      this.onValueChanging = true;
      this.$emit('input', this.generateNewValue());
      this.onValueChanging = false;
    }
  }

  private getDefaultIconUri(id: number): string {
    const d = new api.CharacterIcon();
    d.fileName = id + '.gif';
    d.type = 1;
    return api.CharacterIcon.getUri(d);
  }

  private generateNewValue(): api.CharacterIcon {
    const fileName = this.type === 1 ? this.defaultIconId + '.gif' :
                     this.type === 3 ? md5(this.email.toLowerCase()) :
                     this.value.fileName;
    return new api.CharacterIcon(this.value.id,
                                 this.value.characterId,
                                 this.value.isMain,
                                 this.type,
                                 fileName,
                                 this.file);
  }

  private selectedFile(ev: any) {
    if (ev.target.files && ev.target.files.length > 0) {
      this.file = ev.target.files[0];
      this.onInput();
    }
  }
}
